var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"map",staticClass:"map-content",style:(_vm.styles)},[(_vm.loading)?_c('span',{staticClass:"map-loading"},[_vm._v("Mapa se se načítá...")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }